import ClientFilterIndexes from './ClientFilterIndexes';
import ClientFilterUIState from './ClientFilterUIState';

class ClientFilterStore {
  constructor(filterForm) {
    this.indexes = new ClientFilterIndexes(filterForm);

    this.uiState = new ClientFilterUIState(this.indexes);

    this.uiState.initializeSelections(filterForm.currentFilterValues || []);

    this.initializeFiltering();

    this.defaultFilters = filterForm.defaultFilters || [];
  }

  initializeFiltering() {
    this.uiState.selectedValueIdsByFieldId.forEach((_, fieldId) => {
      this.updateChildren(fieldId);
    });
  }

  toggleValue(fieldId, valueId) {
    if (!this.uiState.selectedValueIdsByFieldId.has(fieldId)) {
      this.uiState.selectedValueIdsByFieldId.set(fieldId, new Set());
    }
    const set = this.uiState.selectedValueIdsByFieldId.get(fieldId);
    if (set.has(valueId)) {
      set.delete(valueId);
    } else {
      set.add(valueId);
    }

    this.updateChildren(fieldId);
  }

  // Recalculate child fields whern parent changes
  updateChildren(parentFieldId) {
    const children = this.indexes.childFieldsByParentFieldId.get(parentFieldId);

    if (!children) {
      return;
    }

    children.forEach((childFieldId) => {
      let resultSet = null;
      const parentFields = this.indexes.parentFieldsByChildFieldId.get(childFieldId);

      parentFields.forEach((parentField) => {
        const selectedParentValue = this.uiState.selectedValueIdsByFieldId.get(parentField);
        if (!selectedParentValue || selectedParentValue.size === 0) {
          return;
        }

        const allowed = new Set();
        selectedParentValue.forEach((parentValueId) => {
          const fieldMap = this.indexes.childValueIdsByParentValueAndField.get(parentValueId);
          if (!fieldMap) {
            return;
          }
          const childValues = fieldMap.get(childFieldId);
          if (!childValues) { 
            return;
          }
          childValues.forEach((v) => allowed.add(v));
        });

        if (!resultSet) {
          resultSet = allowed;
        } else {
          resultSet = new Set([...resultSet].filter((r) => allowed.has(r)));
        }
      });

      // if no parent field is selected, show all field values
      if (!resultSet) {
        resultSet = new Set(this.indexes.fieldValueIdsByFieldId.get(childFieldId));
      }

      // this.uiState.visibleValueIdsByFieldId.set(childFieldId, [...resultSet]);

      const sortedIds = this.indexes.fieldValueIdsByFieldId.get(childFieldId);
      const visibleIds = sortedIds.filter((id) => resultSet.has(id));
      this.uiState.visibleValueIdsByFieldId.set(childFieldId, visibleIds);

      // reset invalid child selections
      const selected = this.uiState.selectedValueIdsByFieldId.get(childFieldId);
      if (selected && selected.size > 0) {
        const updatedSelections = new Set();
        selected.forEach((valueId) => {
          if (resultSet.has(valueId)) {
            updatedSelections.add(valueId);
          }
        });
        this.uiState.selectedValueIdsByFieldId.set(childFieldId, updatedSelections);
      }

      // recursively update deeper levels
      this.updateChildren(childFieldId);
    });
  }

  getFieldsByGroup(groupId) {
    return this.indexes.fieldsByGroupId.get(groupId) || [];
  }

  getVisibleValues(fieldId) {
    const ids = this.uiState.visibleValueIdsByFieldId.get(fieldId) || [];
    return ids.map((id) => this.indexes.fieldValueLookupById.get(id));
  }

  isSelected(fieldId, valueId) {
    const set = this.uiState.selectedValueIdsByFieldId.get(fieldId);
    return set ? set.has(valueId) : false;
  }

  clearAllFilters() {
    this.uiState.selectedValueIdsByFieldId.clear();

    // reset visible values (showing all the field values)
    this.indexes.fieldValueIdsByFieldId.forEach((valueIds, fieldId) => {
      this.uiState.visibleValueIdsByFieldId.set(fieldId, [...valueIds]);
    });
  }

  resetFiltersToDefaultSelections() {
    // clear existing selections
    this.uiState.selectedValueIdsByFieldId.clear();

    // apply defaults
    this.uiState.initializeSelections(this.defaultFilters);

    // re-run filtering
    this.initializeFiltering();
  }
}

export default ClientFilterStore;
